webpackJsonp([35783957827783],{

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bilgewater-champs.6c862319.jpg";

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gangplank-bald.9b0922da.jpg";

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(25);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _articlePreviewModule = __webpack_require__(53);
	
	var _articlePreviewModule2 = _interopRequireDefault(_articlePreviewModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var article = _ref.article;
	
	  if (!article.lastUpdated) {
	    return _react2.default.createElement(
	      'div',
	      { className: _articlePreviewModule2.default.preview },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/blog/' + article.slug },
	        _react2.default.createElement(_gatsbyImage2.default, { alt: '', sizes: article.heroImage.sizes }),
	        _react2.default.createElement(
	          'div',
	          { className: _articlePreviewModule2.default.previewBody },
	          _react2.default.createElement(
	            'h3',
	            { className: _articlePreviewModule2.default.previewTitle },
	            article.title
	          ),
	          _react2.default.createElement(
	            'small',
	            null,
	            article.publishDate
	          ),
	          _react2.default.createElement('p', {
	            dangerouslySetInnerHTML: {
	              __html: article.description.childMarkdownRemark.html
	            }
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: _articlePreviewModule2.default.meta },
	            _react2.default.createElement(
	              'span',
	              null,
	              article.author.name
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              '\u2192'
	            )
	          )
	        )
	      )
	    );
	  } else return _react2.default.createElement(
	    'div',
	    { className: _articlePreviewModule2.default.preview },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/blog/' + article.slug },
	      _react2.default.createElement(_gatsbyImage2.default, { alt: '', sizes: article.heroImage.sizes }),
	      _react2.default.createElement(
	        'div',
	        { className: _articlePreviewModule2.default.previewBody },
	        _react2.default.createElement(
	          'h3',
	          { className: _articlePreviewModule2.default.previewTitle },
	          article.title
	        ),
	        _react2.default.createElement(
	          'small',
	          null,
	          article.publishDate
	        ),
	        _react2.default.createElement(
	          'small',
	          null,
	          'Last Updated: ',
	          article.lastUpdated
	        ),
	        _react2.default.createElement('p', {
	          dangerouslySetInnerHTML: {
	            __html: article.description.childMarkdownRemark.html
	          }
	        }),
	        _react2.default.createElement(
	          'span',
	          { className: _articlePreviewModule2.default.meta },
	          _react2.default.createElement(
	            'span',
	            null,
	            ' ',
	            _react2.default.createElement(_gatsbyImage2.default, { className: _articlePreviewModule2.default.heroImage, alt: article.author.name, sizes: article.author.image.sizes }),
	            article.author.name
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            '\u2192'
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"previewTitle":"src-components----article-preview-module---previewTitle---16pYm","preview":"src-components----article-preview-module---preview---F8ZWM","previewBody":"src-components----article-preview-module---previewBody---cWoy-","tag":"src-components----article-preview-module---tag---27JAs","meta":"src-components----article-preview-module---meta---1o0hi"};

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(25);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _heroModule = __webpack_require__(110);
	
	var _heroModule2 = _interopRequireDefault(_heroModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: _heroModule2.default.hero },
	    _react2.default.createElement(_gatsbyImage2.default, { className: _heroModule2.default.heroImage, alt: data.name, sizes: data.heroImage.sizes }),
	    _react2.default.createElement(
	      'div',
	      { className: _heroModule2.default.heroDetails },
	      _react2.default.createElement(
	        'h2',
	        { className: _heroModule2.default.heroHeadline },
	        data.name
	      ),
	      _react2.default.createElement(
	        'h5',
	        null,
	        data.shortBio.shortBio
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hero":"src-components----hero-module---hero---S__gH","heroImage":"src-components----hero-module---heroImage---DciWV","heroDetails":"src-components----hero-module---heroDetails---3uv8x","heroHeadline":"src-components----hero-module---heroHeadline---jhgHQ","heroTitle":"src-components----hero-module---heroTitle---2LulU"};

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get2 = __webpack_require__(36);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _hero = __webpack_require__(221);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _articlePreview = __webpack_require__(45);
	
	var _articlePreview2 = _interopRequireDefault(_articlePreview);
	
	var _bilgewaterChamps = __webpack_require__(512);
	
	var _bilgewaterChamps2 = _interopRequireDefault(_bilgewaterChamps);
	
	var _gangplankBald = __webpack_require__(514);
	
	var _gangplankBald2 = _interopRequireDefault(_gangplankBald);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RootIndex = function (_React$Component) {
	  _inherits(RootIndex, _React$Component);
	
	  function RootIndex() {
	    _classCallCheck(this, RootIndex);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RootIndex.prototype.render = function render() {
	    var siteTitle = (0, _get3.default)(this, 'props.data.site.siteMetadata.title');
	    var posts = (0, _get3.default)(this, 'props.data.allContentfulBlogPost.edges');
	
	    var _get = (0, _get3.default)(this, 'props.data.allContentfulPage.edges'),
	        author = _get[0];
	
	    return _react2.default.createElement(
	      'div',
	      { style: { background: '#fff' } },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Bilgewater.net - Gangplank Mains" }),
	      _react2.default.createElement(_hero2.default, { data: author.node }),
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'article-list' },
	          _react2.default.createElement(
	            'li',
	            { className: 'card' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/blog' },
	              _react2.default.createElement('img', { alt: 'articles', src: _bilgewaterChamps2.default }),
	              _react2.default.createElement(
	                'h2',
	                { className: '' },
	                'Articles'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'card' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/guides' },
	              _react2.default.createElement('img', { alt: 'articles', src: _gangplankBald2.default }),
	              _react2.default.createElement(
	                'h2',
	                { className: '' },
	                'Guides'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'card' },
	            _react2.default.createElement('img', { alt: 'articles', src: _bilgewaterChamps2.default }),
	            _react2.default.createElement(
	              'h2',
	              { className: '' },
	              'Videos'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return RootIndex;
	}(_react2.default.Component);
	
	exports.default = RootIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-6a39a267878b95801aae.js